import React, { useCallback, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { Form } from '@unform/web';

import { mutate as mutateGlobal } from 'swr';
import api from '../../services/api';
import { useFetchAccounts } from './hooks/useFetchAccounts';
import { useFetchSearchAccounts } from './hooks/useFetchSeachAccounts';
import { useToast } from '../../hooks/toast';

import ButtonPrimaryGree from '../../components/ButtonPrimaryGreen';
import { InputSearch } from '../../components/Form';
import NavbarMenu from '../../components/NavbarMenu';
import ContainerBox from '../../components/ContainerBox';
import ButtonGroupbox from '../../components/ContainerBox/ButtonGroupbox';
import Table from '../../components/Table';
import Loading from '../../components/Loading';
import Pagination from '../../components/Pagination';

import { Container, TotalItems } from './styles';

const Accounts = () => {
  const formRef = useRef(null);

  const [page, setPage] = useState(1);
  const [url, setUrl] = useState('/accounts?page=1');
  const [showAccounts, setShowAccounts] = useState(true);

  const { dataList: accounts, loading, totalItems } = useFetchAccounts(
    `/accounts?page=${page}`
  );

  const {
    dataList: searchAccounts,
    loading: loadingSearch,
  } = useFetchSearchAccounts(url);

  const { addToast } = useToast();

  const head = {
    id: 'ID',
    description: 'Descrição',
    type: 'Tipo',
    account_default: ' ',
  };

  const handleAccountDelete = useCallback(
    async (id) => {
      try {
        if (
          window.confirm(`Tem Certeza que realmente deseja excluir o registro?`)
        ) {
          await api.delete(`/accounts/${id}`);

          mutateGlobal(`/accounts?page=${page}`);
          mutateGlobal(url);

          addToast({
            type: 'success',
            title: 'Cadastro Excluido com Sucesso',
          });
        } else {
          return;
        }
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Não pode excluir contas com movimentações financeiras.',
        });
      }
    },
    [addToast, page, url]
  );

  const handleSubmit = useCallback(() => {
    const input = formRef.current.getFieldValue('inputaccount');

    if (!input) {
      setUrl('/accounts?page=1');
      setPage(1);
      setShowAccounts(true);

      return;
    }

    setUrl(`/accountsearch?search=${input}`);
    setShowAccounts(false);
    formRef.current.reset();
  }, []);

  const handleEnter = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleSubmit();
      }
    },
    [handleSubmit]
  );

  return (
    <Container>
      <NavbarMenu />
      <ContainerBox title="Contas">
        <ButtonGroupbox>
          <Link to="/accounts/newedit">
            <ButtonPrimaryGree icon={FiPlus}>Adicionar</ButtonPrimaryGree>
          </Link>

          <Form ref={formRef} onSubmit={() => {}}>
            <InputSearch
              id="inputaccount"
              name="inputaccount"
              autoComplete="off"
              onKeyDown={(e) => handleEnter(e)}
              handleClick={handleSubmit}
            />
          </Form>
        </ButtonGroupbox>

        {showAccounts && loading && <Loading />}

        {showAccounts && !loading && accounts && (
          <>
            <Table
              head={head}
              data={accounts}
              handleDelete={handleAccountDelete}
              pathname="/accounts/newedit"
              pathnameEdit="/accounts/editinitialbalance"
            />
            {totalItems && (
              <TotalItems>
                <span>
                  Total de registro(s): <b>{totalItems}</b>
                </span>
              </TotalItems>
            )}
            {totalItems > 20 && (
              <Pagination
                setPage={setPage}
                currentPage={page}
                totalItems={totalItems}
              />
            )}
          </>
        )}

        {!showAccounts && loadingSearch && <Loading />}

        {!showAccounts && !loadingSearch && searchAccounts && (
          <Table
            head={head}
            data={searchAccounts}
            handleDelete={handleAccountDelete}
            pathname="/accounts/newedit"
            pathnameEdit="/accounts/editinitialbalance"
          />
        )}
      </ContainerBox>
    </Container>
  );
};

export default Accounts;
